import { ParagraphPlugin as ParagraphPlugin$ } from '@udecode/slate-plugins';

// Paragraph plugin using internal defaults.
// Re-export. See README.md for rationale.
export const ParagraphPlugin = ParagraphPlugin$();
